// @flow
import client from '../../client'

// Types
import type { PointOfInterestsResponse } from '../../api_types'
import type { Options } from './getPointsOfInterest'

// API Endpoint
export const GEOCODE_ENDPOINT = '/locations/geocode/'

/**
 * Return the first part of the nearest address to the given lat/lng
 * @param {Object} data Coordinates information
 * @param {number} data.lat Coordinates latitude
 * @param {number} data.lng Coordinates longitude
 * @param {number} [data.lang] In which language the results should be returned
 * @param {number} [data.provider] 'google maps' or 'baidu maps'
 * @return {Promise|Error} A resolved Promise with string
 */
export const getNearestAddress = (data: Options): Promise<string> =>
  client
    .get(GEOCODE_ENDPOINT, { query: data })
    .then((response: PointOfInterestsResponse) => {
      const firstPlace = response.results && response.results[0]
      const firstAddress = firstPlace && firstPlace.formatted_address
      return firstAddress || ''
    })

export default getNearestAddress
